// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/date-picker/style/index.less
// module id = 972
// module chunks = 1